<template>
  <div class="help-pane" v-loading="fetchLoading" :style="{ minHeight: fetchLoading ? '80px' : 'auto' }">
    <div class="help-li" v-for="(item, index) in info" :key="index">
      <template v-if="item.isVideo">
        <div class="title-content" @click="playVideoHandle(item)">
          <i class="iconfont iconbofang-mian play-icon"></i>
          <span>{{ item.title }}</span>
        </div>
      </template>
      <template v-else>
        <div class="title-content" :class="expandArr[index] ? 'is-expand' : ''" @click="expandHandle(index)">
          <i class="iconfont iconzhankai" v-if="expandArr[index]"></i>
          <i class="iconfont iconzuozhankai" v-else></i>
          <span>{{ item.title }}</span>
        </div>
        <div class="tip-content" v-show="expandArr[index]">
          <ul class="enum-ul" v-show="(item.enum || []).length > 0">
            <li class="enum-li" v-for="(enumItem, enumIndex) in item.enum" :key="enumIndex">
              <span>{{ enumItem }}</span>
            </li>
          </ul>
          <div class="tip-ul" v-show="(item.tip || []).length > 0">
            <div class="tip-li" v-for="(tipItem, tipIndex) in item.tip" :key="tipIndex">
              <span>{{ tipItem }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <video-player v-if="videoModel.show" :show.sync="videoModel.show" :info="videoModel.info" />
  </div>
</template>

<script>
import videoPlayer from '@/components/videoPlayer';

import helpEnum from '@/assets/helpEnum.json';
import { services } from '@/service';

export default {
  components: { videoPlayer },
  data() {
    return {
      expandArr: {},
      videoModel: {},
      fetchLoading: true,
      remoeHelpEnum: {}
    };
  },
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    info() {
      return this.fetchLoading ? [] : this.remoeHelpEnum[this.mode] || helpEnum[this.mode] || [];
    }
  },
  watch: {
    info: {
      handler(val) {
        if (val.length > 0) {
          this.expandArr = { 0: true };
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.initHandle();
  },
  methods: {
    async initHandle() {
      try {
        const remoeHelpEnum = {};

        const result = await services.courseware.getCourseCrime({
          size: 5000,
          query: {
            bool: { must: [{ terms: { 'typename.keyword': ['实证详情页教学'] } }] }
          },
          sort: [{ sort: 'desc' }]
        });

        const groups = {
          研究点详情页: { helpKey: 'research', list: [] },
          数据清洗页: { helpKey: 'dataCleaner', list: [] }
        };

        result.hits.hits.forEach(({ _source }) => {
          const groupItem = groups[_source.category];
          if (groupItem) {
            if (_source.link && _source.link.indexOf('http') === -1 && _source.link.slice(0, 2) !== '//') {
              _source.link = `${window.location.protocol}//${window.location.host}${_source.link}`;
            }
            groupItem.list.push({ isVideo: true, title: _source.title, url: _source.link });
          }
        });

        Object.keys(groups).forEach(label => {
          if (groups[label].list.length > 0) {
            remoeHelpEnum[groups[label].helpKey] = groups[label].list;
          }
        });

        this.remoeHelpEnum = remoeHelpEnum;
      } catch (err) {
        this.$error(err);
      } finally {
        this.fetchLoading = false;
      }
    },
    expandHandle(index) {
      if (this.expandArr[index]) {
        this.expandArr[index] = false;
      } else {
        if (Object.prototype.hasOwnProperty.bind(this.expandArr)(index)) {
          this.expandArr[index] = true;
        } else {
          this.$set(this.expandArr, index, true);
        }
      }
    },
    playVideoHandle(item) {
      this.videoModel = {
        show: true,
        info: {
          url: item.url,
          title: item.title
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.help-pane {
  .help-li {
    margin-top: 15px;

    &:first-child {
      margin-top: 0;
    }

    &:first-child {
      margin-top: 0;
    }

    .title-content {
      font-size: 13px;
      color: rgba(#2c3443, 0.8);
      line-height: 18px;
      cursor: pointer;

      &.is-expand {
        color: #409eff;
      }

      &:hover {
        color: #409eff;
      }

      .iconfont {
        font-size: 14px;
        margin-right: 4px;
      }
    }

    .tip-content {
      box-sizing: border-box;
      font-size: 12px;
      color: rgba(#3d465a, 0.8);
      line-height: 17px;
      padding-left: 15px;

      .enum-ul {
        box-sizing: border-box;
        padding-left: 12px;

        .enum-li {
          margin: 10px;
        }
      }

      .tip-ul {
        .tip-li {
          margin: 10px;
        }
      }
    }
  }
}
</style>
